import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import usePrams -> to get showid from url in details page
import { searchQuery } from "../../redux/actions/FetchActions";
import SearchCard from "./SearchCard";
import { fetchQuery } from "../../redux/reducers/FetchReducer";

function SearchList({ keyword }) {
    let [ num, setNum ] = useState(1);
    const [currentPage, setCurrentPage ] = useState(1);
    const dispatch = useDispatch();
    const bothShows = useSelector((state) => state.allData.searches); // state.allData.bothShows for all bothShows
    const pages = [
        {page: num},
        {page: num + 1},
        {page: num + 2},
    ];
    
    useEffect(() => {
        searchQuery(keyword, currentPage).then((res)=>{
            dispatch(fetchQuery(res.data.results));
        });        
    }, [currentPage]);
    
    function Next() {
        num < 60 && setNum(++num);
    }
    function Back() {
        num > 1 && setNum(--num);
    }
    
    return (
        <div className="pb-5 px-5 overflow-y-auto justify-items-center">
            { bothShows?.map((movie) => {
                return <SearchCard key={movie.id} movie={movie} />
            })}
            
            <div className="pagination py-4 flex bg-white rounded-md font-sans rounded-1-1g">
                <button onClick={Back} className="h-12 border-2 border-r-0 rounded-md border-sky-600 w-12 hover:bg-sky-400 hover:text-white" >
                    Back
                </button>

                {
                    pages.map((page, index) => (
                        <button key={index} onClick={() => setCurrentPage(page.page)} className="h-12 border-2 border-r-0 rounded-md border-sky-600 w-12  hover:bg-sky-400 hover:text-white">{page.page}</button>
                    ))
                }

                <button onClick={Next} className="h-12 border-2 border-sky-600 w-12 rounded-md hover:bg-sky-400 hover:text-white" >
                    Next
                </button>
            </div>
        </div>
        
    );

}

export default SearchList;
